import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import './Comparison.css';

const rows = [
  { label:'Monthly Cost',    diesel:'36,500 – 53,500 THB', axion:'21,900 – 38,000 THB' },
  { label:'Fuel / Energy',   diesel:'18,000 – 25,000 THB', axion:'6,000 – 10,000 THB'  },
  { label:'Maintenance',     diesel:'3,000 – 6,000 THB',   axion:'Included'             },
  { label:'Insurance',       diesel:'1,500 – 2,500 THB',   axion:'Included'             },
  { label:'Taxes',           diesel:'500 – 1,000 THB',     axion:'Included'             },
  { label:'Downtime Risk',   diesel:'High',                 axion:'Low (SLA + Backup)'  },
  { label:'Tracking & Data', diesel:'None',                 axion:'Axion OS'             },
];

const badges = ['GDP Compliant','GDPMD Ready','ISO Standards','Zero Emissions'];

export default function Comparison() {
  return (
    <section className="compare-section" id="comparison">
      <div className="compare-inner">
        <div className="compare-left">
          <span className="section-label">Diesel vs Axion</span>
          <h2 className="section-title section-title--dark">Lower Cost.<br />Every Month.</h2>
          <p className="section-desc section-desc--dark">
            Real saving from day one. No more unexpected expenses — every cost bundled into one simple monthly subscription.
          </p>
          <div className="compare-table">
            <div className="compare-row compare-row--head">
              <span>Cost Item</span><span>Diesel</span><span>Axion EV</span>
            </div>
            {rows.map(r => (
              <div key={r.label} className="compare-row">
                <span className="cr-label">{r.label}</span>
                <span className="cr-diesel">{r.diesel}</span>
                <span className="cr-axion">{r.axion}</span>
              </div>
            ))}
          </div>
          <p className="compare-note">*Costs vary based on usage and vehicle type.</p>
        </div>

        <div className="compare-right">
          <div className="savings-card">
            <p className="savings-eyebrow">Your Potential Savings</p>
            <p className="savings-amount">10,000 – 20,000 THB</p>
            <p className="savings-sub">per vehicle / month</p>
            <div className="savings-divider" />
            <p className="savings-fleet">
              That's up to <strong>2.4M THB per year</strong><br />for a fleet of 10 vehicles.
            </p>
            <Link to="/contact" className="savings-cta">
              Calculate Your Saving <ArrowRight size={16} />
            </Link>
          </div>
          <div className="compare-badges">
            {badges.map(b => (
              <div key={b} className="compare-badge"><span>✓</span>{b}</div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
